import { DateTime } from 'luxon';

const displayDate = date => date.toLocaleString(DateTime.DATE_MED);
const displayDateTime = dateTime =>
  dateTime.toLocaleString(DateTime.DATETIME_MED);

export const displayTimeFromISOString = isoString =>
  displayDateTime(DateTime.fromISO(isoString));

export const displayTimeFromJSDate = time =>
  displayDateTime(DateTime.fromJSDate(time));

export const displayTimeFromTimestamp = timestamp =>
  displayTimeFromJSDate(timestamp.toDate());

export const displayDateFromISOString = isoString =>
  displayDate(DateTime.fromISO(isoString));

export const displayDateFromJSDate = time =>
  displayDate(DateTime.fromJSDate(time));

export const displayDateFromTimestamp = timestamp =>
  displayDateFromJSDate(timestamp.toDate());
